import { Text } from '@pairy/pds-react';
import Image from 'next/image';

import handleFreeBadgeLinkOpen from '../../../../utils/handleFreeBadgeLinkOpen';

import * as Styled from './index.styles';

interface Props {
  userSubscriptionPlan: string;
}

const MobileFormFreeBadge = ({ userSubscriptionPlan }: Props) => {
  const isFreeBadgeVisible = () => {
    return userSubscriptionPlan === 'Free';
  };

  return (
    <Styled.Container
      gap={8}
      padding={{ x: 16, y: 12 }}
      className={isFreeBadgeVisible() ? 'is-visible' : ''}
      alignItems="center"
      justifyContent="center"
      width="fit-content"
      onClick={() => {
        handleFreeBadgeLinkOpen();
      }}
    >
      <Text variant="sm-semibold" color="skyblue_600">
        Powered by
      </Text>
      <Image
        src="/images/salesclue_logo_default.png"
        width={75}
        height={17}
        alt={'SalesClue'}
        unoptimized
      />
    </Styled.Container>
  );
};

export default MobileFormFreeBadge;
